import { SVGIcon } from '@system1/lib-react';
import classNames from 'classnames';
import { ExistingQuestion as ExistingQuestionType } from 'components/configure-modals/configure-from-existing-questions/types';

interface ExistingQuestionProps {
  item: ExistingQuestionType;
  onSelect?: (ad: ExistingQuestionType) => void;
  isSelected?: boolean;
}

export const ExistingQuestion = ({
  item,
  onSelect,
  isSelected = false,
}: ExistingQuestionProps) => {
  return (
    <div
      className={classNames('existing-question', {
        selected: isSelected,
      })}
      onClick={() => {
        if (onSelect) {
          onSelect(item);
        }
      }}
    >
      <div className="existing-question__info">
        <div className="existing-question__name" title={item.questionName}>
          {item.questionName}
        </div>
        <div
          className="existing-question__description"
          title={item.questionText}
        >
          {item.questionText}
        </div>
        <div className="existing-question__additional-info">
          {item.questionTemplateName} - {item.questionValueCount} responses
        </div>
      </div>
      <div className="existing-question__right-arrow">
        <SVGIcon src="/images/icons/arrow-right.svg" />
      </div>
    </div>
  );
};
